import { render, staticRenderFns } from "./PropertyPriceDetails.vue?vue&type=template&id=43e7a074&scoped=true"
import script from "./PropertyPriceDetails.vue?vue&type=script&lang=js"
export * from "./PropertyPriceDetails.vue?vue&type=script&lang=js"
import style0 from "./PropertyPriceDetails.vue?vue&type=style&index=0&id=43e7a074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e7a074",
  null
  
)

export default component.exports